"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledLabel = exports.StyledFontAwesomeIcon = void 0;
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _reactFontawesome = require("@fortawesome/react-fontawesome");
var _reactstrap = require("reactstrap");
var _templateObject, _templateObject2;
var StyledLabel = exports.StyledLabel = (0, _styledComponents["default"])(_reactstrap.Label)(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n  cursor: pointer;\n"])));
var StyledFontAwesomeIcon = exports.StyledFontAwesomeIcon = (0, _styledComponents["default"])(_reactFontawesome.FontAwesomeIcon)(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2["default"])(["\n  margin-right: 5px;\n"])));